<template>
  <div class="page forgot-password">
    <div class="logo">
      <el-image class="logo-img" :src="logoImg" />
      <span class="logo-txt"> </span>
    </div>
    <div class="container">
      <div class="contain-right">
        <div class="theme">
          <div class="title">忘记密码</div>
          <div class="ornament"></div>
        </div>
        <el-form class="rule-form" ref="forgetForm" :model="formData" :rules="formRules">
          <!--重置密码-->
          <el-form-item label>
            <div class="login-input">
              <el-input v-model="baseVal" class="input-full" placeholder="请输入手机号或邮箱" @change="inputType()" />
            </div>
          </el-form-item>
          <el-form-item label>
            <div class="login-input">
              <el-input v-model="formData.code" class="input-full" placeholder="请输入验证码">
                <template slot="append" v-if="showTimer">
                  <el-button type="text" class="code_text" :loading="codeLoad" @click="getCode()">
                    获取验证码
                  </el-button>
                </template>
                <template slot="append" v-if="!showTimer">
                  <div class="getCode">
                    <span> {{ count + "s" }}后重发 </span>
                  </div>
                </template>
              </el-input>
            </div>
          </el-form-item>
          <el-form-item label prop="password">
            <div class="login-input">
              <el-input v-model="formData.password" class="input-full" placeholder="请输入密码" clearable>
              </el-input>
            </div>
          </el-form-item>
          <el-form-item label prop="confirm_password">
            <div class="login-input">
              <el-input v-model="formData.confirm_password" class="input-full" placeholder="确认密码" clearable>
              </el-input>
            </div>
          </el-form-item>
        </el-form>
        <div class="login-item btns">
          <el-button class="btn" type="primary" round :loading="submitLoad" @click="handleSubmit('forgetForm')">
            提交
          </el-button>
          <el-button type="text" @click="toLogin"> 返回登录 </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sendsmscode, sendemailcode, forgetpw } from "@/api/user";
import { getSiteInfo } from "@/api/banner";
import { validatePhone, validEmail } from "@/utils/validate";
import md5 from "js-md5";
export default {
  name: "Register",
  components: {},
  data() {
    const pwdCheck = (rule, value, callback) => {
      if (value != this.formData.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      logoImg: require("@/assets/logo.png"),
      loginText: "文化项目管理平台",
      schoolid: null, // 学校
      formData: {
        password: "",
        confirm_password: "",
        email: "",
        mobile: "",
        code: "",
      },
      formRules: {
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            pattern: /(?![A-Z]*$)(?![a-z]*$)(?![0-9]*$)(?![^a-zA-Z0-9]*$)/,
            message: "请输入至少7位以上含字母、数字或特殊符号的组合密码",
          },
        ],
        confirm_password: [
          { required: true, message: "请输入确认密码", trigger: "blur" },
          { required: true, validator: pwdCheck, trigger: "blur" },
        ],
      },
      baseVal: "",
      isInputType: "mobile", // 输入类型
      count: "", // 计时器计数
      showTimer: true, // 显示计时器
      codeLoad: false, // 二位码防抖
      submitLoad: false, // 提交防抖
    };
  },
  created() {
    this.getSite(); // 获取网站信息
  },
  methods: {
    // 判断输入类型
    inputType() {
      if (!validEmail(this.baseVal) && !validatePhone(this.baseVal)) {
        this.$message.warning("请输入正确的手机号或邮箱地址");
      } else {
        this.showTimer = true;
        if (validEmail(this.baseVal)) {
          this.isInputType = "email";
          this.formData.email = this.baseVal;
          this.formData.code = "";
        } else {
          this.isInputType = "mobile";
          this.formData.mobile = this.baseVal;
          this.formData.sms_code = "";
        }
      }
    },
    // 验证码
    getCode() {
      this.codeLoad = true;
      if (this.isInputType === "email") {
        // 邮箱验证码
        if (validEmail(this.formData.email)) {
          const time = new Date().getTime();
          const params = {
            email: this.formData.email,
            sign: md5(md5(this.formData.email) + time),
            time: time,
          };
          sendemailcode(params)
            .then((response) => {
              if (response.code === 0) {
                this.codeLoad = false;
                this.$message.success("验证码发送成功!");
                const TIME_COUNT = 60;
                if (!this.timer) {
                  this.count = TIME_COUNT;
                  this.showTimer = false;
                  this.timer = setInterval(() => {
                    if (this.count > 0 && this.count <= TIME_COUNT) {
                      this.count--;
                    } else {
                      this.showTimer = true;
                      clearInterval(this.timer);
                      this.timer = null;
                    }
                  }, 1000);
                }
                this.formData.code = response.data;
              } else {
                this.codeLoad = false;
                this.$message({
                  message: response.message,
                  type: "error",
                });
              }
            })
            .catch(() => {
              this.codeLoad = false;
            });
        } else {
          this.codeLoad = false;
          this.$message({
            message: "请输入正确的邮箱!",
            type: "error",
          });
        }
      } else {
        // 手机验证码
        if (validatePhone(this.formData.mobile)) {
          const time = new Date().getTime();
          const params = {
            mobile: this.formData.mobile,
            sign: md5(md5(this.formData.mobile) + time),
            time: time,
          };
          sendsmscode(params)
            .then((response) => {
              const { data } = response;
              if (response.code === 0) {
                this.codeLoad = false;
                const TIME_COUNT = 60;
                if (!this.timer) {
                  this.count = TIME_COUNT;
                  this.showTimer = false;
                  this.timer = setInterval(() => {
                    if (this.count > 0 && this.count <= TIME_COUNT) {
                      this.count--;
                    } else {
                      this.showTimer = true;
                      clearInterval(this.timer);
                      this.timer = null;
                    }
                  }, 1000);
                }
              } else if (response.data && response.data.sms_code) {
                this.codeLoad = false;
                this.formData.sms_code = response.data.sms_code;
              } else {
                this.codeLoad = false;
                this.$message({
                  message: response.message,
                  type: "error",
                });
              }
            })
            .catch(() => {
              this.codeLoad = false;
            });
        } else {
          this.codeLoad = false;
          this.$message({
            message: "请输入正确的手机号码!",
            type: "error",
          });
        }
      }
    },
    // 提交
    handleSubmit(formName) {
      this.submitLoad = true;
      let params = {
        password: this.formData.password,
        confirm_password: this.formData.confirm_password,
        code: this.formData.code,
      };
      if (this.isInputType === "mobile") {
        params.mobile = this.formData.mobile;
      } else {
        params.email = this.formData.email;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          forgetpw(params)
            .then((response) => {
              if (response.code === 0) {
                this.submitLoad = false;
                this.$message({
                  message: "密码重置成功！！！",
                  type: "success",
                });
                this.$router.push({ path: "/login" });
              }
            })
            .catch((error) => {
              this.submitLoad = false;
            });
        } else {
          this.submitLoad = false;
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 去登录
    toLogin() {
      this.$router.push("/login");
    },
    // 获取网站信息
    getSite() {
      getSiteInfo()
        .then((res) => {
          if (res.code === 0 && res.data) {
            let resData = res.data;
            this.logoImg = resData.back_head_logo;
            this.loginText = resData.back_name;
          }
        })
        .catch((error) => { });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  width: 100%;
  height: 100vh;
  background: #f5f5f5 url("~@/assets/login/bg.jpg") no-repeat;
  background-size: 100% 100%;
  background-position: center;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  .logo {
    position: absolute;
    left: 3%;
    top: 3%;

    .logo-img {
      height: 8vh;
    }
  }

  .container {
    width: 32%;
    max-width: 620px;
    height: 68vh;
    display: flex;
    justify-content: center;
    align-items: center;

    .contain-right {
      flex: 1;
      max-width: 600px;
      padding: 40px 60px;
      background-color: #fff;
      border-radius: 20px;

      .theme {
        width: 100%;
        min-height: 40px;

        .title {
          color: #000;
          font-size: 24px;
          font-weight: bold;
          line-height: 1.5;
          text-align: center;
          margin-bottom: 20px;
        }

        .theme-logo {
          width: auto;
          height: 60px;
        }

        .ornament {
          width: 100%;
          min-height: 10px;

          .img {
            width: 100%;
          }
        }
      }

      .rule-form {
        width: 100%;

        .login-input {
          padding: 20px 0 10px;
          border-bottom: 1px solid #ddd;

          .icon {
            width: 20px;
            height: 20px;
          }

          .code_text {
            color: #005cbb !important;
            padding: 10px;
          }

          .getCode {
            color: #909399;
          }

          ::v-deep .input-full {
            flex: 1;

            .el-input__inner {
              border: none;
            }

            .el-input-group__prepend,
            .el-input-group__append {
              background-color: transparent;
              border-color: transparent;
            }
          }
        }
      }

      ::v-deep .el-form-item {
        margin-bottom: 10px;
      }

      .login-item {
        width: 100%;
        margin-bottom: 10px;
      }

      .login-item.btns {
        text-align: center;
        margin-top: 50px;

        .btn {
          width: 100%;
          line-height: 30px;
          margin: 0;
          margin-bottom: 10px;
          border-radius: 30px;
        }
      }
    }
  }
}

@media screen and (max-width: 640px) {
  .page {
    background-size: cover;

    .logo {
      left: 5%;
      top: 2%;

      .logo-img {
        height: 5vh;
      }
    }

    .container {
      width: 90%;
      max-width: 400px;
      height: auto;
      min-height: 50vh;

      .contain-right {
        padding: 30px 20px;
        border-radius: 12px;

        .theme {
          .title {
            font-size: 20px;
            margin-bottom: 10px;
          }
        }

        .rule-form {
          .login-input {
            padding: 10px 0 5px;
          }
        }
      }
    }
  }
}

@media screen and (min-width: 640px) and (max-width: 1200px) {
  .page {
    .container {
      width: 50%;
      max-width: 500px;

      .contain-right {
        padding: 30px 40px;
      }
    }
  }
}

@media screen and (max-width: 640px) {
  .page {
    .logo {
      padding: 15px 0;

      .logo-img {
        height: 40px;
      }
    }

    .container {
      width: 90%;
      max-width: 400px;
      height: auto;

      .contain-right {
        padding: 25px 20px;
      }
    }
  }
}
</style>